import { useGetAuthMe } from "@birdwatch/client";
import { type PropsWithChildren, useEffect } from "react";
import { useImpersonationSession } from "@/features/shared/impersonation";
import { useSupportChat } from "@/features/shared/support-chat";

export const SupportChatIdentify = ({ children }: PropsWithChildren) => {
  const { identify } = useSupportChat();
  const impersonation = useImpersonationSession();
  const { data: me, isLoading } = useGetAuthMe()
    .query({ includes: ["intercomIntegration"] })
    .get({ enabled: !impersonation });

  useEffect(() => {
    // An admin browsing as a customer must not appear in the customer's
    // support chat as that customer; nothing is booted in the frame.
    if (impersonation) return;
    // Don't boot/update while loading to avoid using empty values
    if (isLoading || !me?.id) return;
    identify({
      userId: me.id,
      email: me.email,
      name: me.name,
      phone: me.phone || undefined,
      userHash: me.intercomIntegration?.userHash,
    });
    // `identify` is deliberately not a dependency: it changes identity the
    // first time it runs (it closes over `isReady`), so listing it here would
    // re-identify on every render.
  }, [me, impersonation]);

  return <>{children}</>;
};
